import React from "react";
import PageTitle from "../PageTitle";
import { doRequest } from "../../helper";
import $ from "jquery";
import { CSVLink } from "react-csv";

const headers = [
  { label: "State Name", key: "state" },
  { label: "Post Count", key: "postCount" },
];
const headers1 = [
  { label: "State Name", key: "state" },
  { label: "City Name", key: "constituency" },
  { label: "Post Count", key: "postCount" },
];
const headers3 = [
  { label: "Leader Name", key: "user_name_display" },
  { label: "State name", key: "state" },
  { label: "Post Count", key: "postCount" },
];

const headers4 = [
  { label: "Leader Name", key: "user_name_display" },
  { label: "State Name", key: "state" },
  { label: "City Name", key: "constituency" },
  { label: "Post Count", key: "postCount" },
];

export default class SmDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      stateitem: [],
      response: null,
      status: "Active",
    };
    this.stateList = this.stateList.bind(this);
    this.constList = this.constList.bind(this);
    this.leaderList = this.leaderList.bind(this);
    this.mpmlaList = this.mpmlaList.bind(this);
  }
  componentDidMount() {
    this.stateList();
  }
  componentWillReceiveProps(nextProps) {}

  stateList = (loadmore) => {
    var settings = {
      url: "https://mmapi.narendramodi.in/v1/mahila-rds/getData",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        action: "smstate",
      }),
    };
    let ref = this;
    $.ajax(settings).done(function (result) {
      try {
        if (result.resultFlag && result.resultFlag == "1") {
          let loadMoreItems = loadmore
            ? [...ref.state.items, ...result.response]
            : result.response;
          let postCount = 0;
          loadMoreItems.map((item) => {
            postCount += item["postCount"];
          });
          ref.setState(
            {
              response: result,
              items: result.response,
              post_count: postCount,
              type: "smstate",
            },
            () => {
              $("#loader").css({ display: "none" });
            }
          );
        }
      } catch (ex) {}
    });
  };
  constList = (loadmore) => {
    var settings = {
      url: "https://mmapi.narendramodi.in/v1/mahila-rds/getData",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        action: "smconstituency",
      }),
    };
    let ref = this;
    $.ajax(settings).done(function (result) {
      try {
        if (result.resultFlag && result.resultFlag == "1") {
          let loadMoreItems = loadmore
            ? [...ref.state.items, ...result.response]
            : result.response;
          let postCount = 0;
          loadMoreItems.map((item) => {
            postCount += item["postCount"];
          });
          ref.setState(
            {
              response: result,
              items: result.response,
              post_count: postCount,
              type: "smconstituency",
            },
            () => {
              $("#loader").css({ display: "none" });
            }
          );
        }
      } catch (ex) {}
    });
  };
  leaderList = (loadmore) => {
    var settings = {
      url: "https://mmapi.narendramodi.in/v1/mahila-rds/getData",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        action: "smleader",
      }),
    };
    let ref = this;
    $.ajax(settings).done(function (result) {
      try {
        if (result.resultFlag && result.resultFlag == "1") {
          let loadMoreItems = loadmore
            ? [...ref.state.items, ...result.response]
            : result.response;
          let postCount = 0;
          loadMoreItems.map((item) => {
            postCount += item["postCount"];
          });
          ref.setState(
            {
              response: result,
              items: result.response,
              post_count: postCount,
              type: "smleader",
            },
            () => {
              $("#loader").css({ display: "none" });
            }
          );
        }
      } catch (ex) {}
    });
  };
  mpmlaList = (loadmore) => {
    var settings = {
      url: "https://mmapi.narendramodi.in/v1/mahila-rds/getData",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        action: "mpsmleader",
      }),
    };
    let ref = this;
    $.ajax(settings).done(function (result) {
      try {
        if (result.resultFlag && result.resultFlag == "1") {
          let loadMoreItems = loadmore
            ? [...ref.state.items, ...result.response]
            : result.response;
          let postCount = 0;
          loadMoreItems.map((item) => {
            postCount += item["postCount"];
          });
          ref.setState(
            {
              response: result,
              items: result.response,
              post_count: postCount,
              type: "mpsmleader",
            },
            () => {
              $("#loader").css({ display: "none" });
            }
          );
        }
      } catch (ex) {}
    });
  };

  render() {
    var bread = "Sampark Se Samarthan / Dashboard";
    var items = this.state.items;
    var type = this.state.type;
    return (
      <div>
        <PageTitle
          title="#Sampark Se Samarthan"
          bread={bread}
          Count={this.state.post_count}
        />
        <div className="wrapper wrapper-content">
          <div>
            <h3>PostCount Filter by : </h3>
            <h3
              style={{
                margin: "-30px 18px 15px 0px",
                color: "#139d13",
                right: "0px",
                position: "absolute",
              }}
            >
              Count : {this.state.post_count && this.state.post_count}
            </h3>
          </div>
          <div className="form-inline form_right" style={{ top: "0px" }}>
            <div className="row row_date_div">
              <button
                style={{
                  padding: "0px 10px",
                  "border-radius": "20px",
                  "margin-left": "10px",
                }}
                className="btn btn-info"
                onClick={() => {
                  this.stateList();
                }}
              >
                State
              </button>
              <button
                style={{
                  padding: "0px 10px",
                  "border-radius": "20px",
                  "margin-left": "10px",
                }}
                className="btn btn-info"
                onClick={() => {
                  this.constList();
                }}
              >
                Constituency
              </button>
              <button
                style={{
                  padding: "0px 10px",
                  "border-radius": "20px",
                  "margin-left": "10px",
                }}
                className="btn btn-info"
                onClick={() => {
                  this.leaderList();
                }}
              >
                Leader
              </button>
              <button
                style={{
                  padding: "0px 10px",
                  "border-radius": "20px",
                  "margin-left": "10px",
                }}
                className="btn btn-info"
                onClick={() => {
                  this.mpmlaList();
                }}
              >
                MP Leader
              </button>
              <button
                style={{
                  padding: "0px 10px",
                  "border-radius": "20px",
                  "margin-left": "10px",
                }}
                className="btn-success"
                onClick={() => {
                  window.location.reload();
                }}
              >
                Clear filters
              </button>
              {type === "smstate" && (
                <CSVLink
                  style={{
                    margin: "0px 0px -6px 30px",
                    right: "0px",
                    position: "absolute",
                  }}
                  data={items}
                  headers={headers}
                  filename="Samparksesamarthan_Statecount.csv"
                >
                  <img
                    style={{ width: "30px" }}
                    alt="image"
                    src="/img/filetype-csv.svg"
                  />
                </CSVLink>
              )}
              {type === "smconstituency" && (
                <CSVLink
                  style={{
                    margin: "0px 0px -6px 30px",
                    right: "0px",
                    position: "absolute",
                  }}
                  data={items}
                  headers={headers1}
                  filename="Samparksesamarthan_Constituencycount.csv"
                >
                  <img
                    style={{ width: "30px" }}
                    alt="image"
                    src="/img/filetype-csv.svg"
                  />
                </CSVLink>
              )}
              {type === "smleader" && (
                <CSVLink
                  style={{
                    margin: "0px 0px -6px 30px",
                    right: "0px",
                    position: "absolute",
                  }}
                  data={items}
                  headers={headers3}
                  filename="Samparksesamarthan_Leadercount.csv"
                >
                  <img
                    style={{ width: "30px" }}
                    alt="image"
                    src="/img/filetype-csv.svg"
                  />
                </CSVLink>
              )}
              {type === "mpsmleader" && (
                <CSVLink
                  style={{
                    margin: "0px 0px -6px 30px",
                    right: "0px",
                    position: "absolute",
                  }}
                  data={items}
                  headers={headers4}
                  filename="Samparksesamarthan_MpmlaLeadercount.csv"
                >
                  <img
                    style={{ width: "30px" }}
                    alt="image"
                    src="/img/filetype-csv.svg"
                  />
                </CSVLink>
              )}
            </div>
          </div>
        </div>
        <hr style={{ margin: "0px", "border-top": "1px solid black" }} />
        <div className="wrapper wrapper-content">
          <div className="row">
            <div className="col-lg-12">
              <div className="kamal_list">
                {type === "smstate" && (
                  <table className="table mt-5">
                    <thead className="thead-dark">
                      <tr>
                        <th>State</th>
                        <th>Post Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(items) &&
                        items.map((value, index) => {
                          return (
                            <tr>
                              <td>{value.state ? value.state : "null"}</td>
                              <td>{value.postCount ? value.postCount : "0"}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                )}
                {type === "smconstituency" && (
                  <table className="table mt-5">
                    <thead className="thead-dark">
                      <tr>
                        <th>State</th>
                        <th>Constituency</th>
                        <th>Post Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(items) &&
                        items.map((value, index) => {
                          return (
                            <tr>
                              <td>{value.state ? value.state : "null"}</td>
                              <td>
                                {value.constituency
                                  ? value.constituency
                                  : "null"}
                              </td>
                              <td>{value.postCount ? value.postCount : "0"}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                )}
                {type === "smleader" && (
                  <table className="table mt-5">
                    <thead className="thead-dark">
                      <tr>
                        <th>User Name</th>
                        <th>State</th>
                        <th>Post Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(items) &&
                        items.map((value, index) => {
                          return (
                            <tr>
                              <td>
                                {value.user_name_display
                                  ? value.user_name_display
                                  : "null"}
                              </td>
                              <td>{value.state ? value.state : "null"}</td>
                              <td>{value.postCount ? value.postCount : "0"}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                )}
                {type === "mpsmleader" && (
                  <table className="table mt-5">
                    <thead className="thead-dark">
                      <tr>
                        <th>User Name</th>
                        <th>State</th>
                        <th>Constituency</th>
                        <th>Post Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(items) &&
                        items.map((value, index) => {
                          return (
                            <tr>
                              <td>
                                {value.user_name_display
                                  ? value.user_name_display
                                  : "null"}
                              </td>
                              <td>{value.state ? value.state : "null"}</td>
                              <td>
                                {value.constituency
                                  ? value.constituency
                                  : "null"}
                              </td>
                              <td>{value.postCount ? value.postCount : "0"}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/SamparkSeSamarthan/Dashboard.jsx